import { Record } from 'immutable';
import ErrorRecord from '~/data/ErrorRecord';

const keys: Fields = {
  isLoading: false,
  isFinished: false,
  error: undefined,
};

interface Fields {
  isLoading: boolean;
  isFinished: boolean;
  error?: ErrorRecord;
}

export default class ISIMCodeValidatorRecord extends Record<Fields>(keys) {}
